// extracted by mini-css-extract-plugin
export default {"mensagem":"IconeStatus_mensagem__E3iMV"};